import { autoinject, transient } from 'aurelia-dependency-injection';
import { bindable } from 'aurelia-templating';

//Load styles
require("./comp-toggle.scss");

@autoinject
@transient()
export class CompToggle {

	@bindable
	public options: ToggleModel[];

	@bindable
	public selectedOption: ToggleModel;

	@bindable
	public id: string;

	@bindable
	public onOptionSelected: (option: ToggleModel) => void;

	attached() {

		if(this.options != null){
			
			//Sort options by index
			this.options.sort((a, b) => a.index - b.index);
	
			//If no option is selected, select first option by default
			if(this.selectedOption == null){
			
				this.selectedOption = this.options[0];		
			}
		}
	}

	selectOption(option: ToggleModel) {
		
		//Ignore, if the option is already selected
		if(this.selectedOption == option){
			return;
		}

		this.selectedOption = option;
	}
}

export interface ToggleModel {
	index: number;
	title: string;
	vm?: any;
	path?: string;
	model?: any;
	show: boolean | (() => boolean);
	id?: string;
}